import { TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';
import { useOutletContext } from 'react-router-dom';

import { TabPaper } from '@/components/atoms/TabPaper';
import { LoadingButton } from '@/components/molecules/LoadingButton';
import { UserPreferencesContextType } from '@/DTOs/userPreferences';
import { useTranslator } from '@/hooks/useTranslator';

export const SettingsLanguageTab: React.FC = (): React.ReactElement => {
  const context = useOutletContext<UserPreferencesContextType>();
  const { preferences, loading, update } = context;

  const tr = useTranslator();

  const [language, setLanguage] = React.useState(preferences.language);

  const handleLanguageChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>): void => {
      const { value } = event.target;
      switch (value) {
        case 'en':
        case 'es':
        case 'pt':
          setLanguage(value);
          break;
        default:
          console.warn(`Unsupported language: ${value}`);
          break;
      }
    },
    [],
  );

  const handleSave = React.useCallback(async (): Promise<void> => {
    await update({ language: language });
  }, [language, update]);

  return (
    <TabPaper>
      <Box display="flex" flexDirection="column" gap={5}>
        <Box>
          <Typography variant="h7" component="h6">
            {tr('LANGUAGE')}
          </Typography>
          <Box width={422} mt={2}>
            <TextField
              label={tr('PREFERRED_LANGUAGE')}
              placeholder={tr('PREFERRED_LANGUAGE')}
              fullWidth={true}
              value={language}
              onChange={handleLanguageChange}
              select={true}>
              <MenuItem value="en">English</MenuItem>
              <MenuItem value="pt">Português</MenuItem>
              <MenuItem value="es">Español</MenuItem>
            </TextField>
          </Box>
        </Box>
        <Box>
          <LoadingButton variant="dark" loading={loading} onClick={handleSave}>
            {tr('SAVE_CHANGES')}
          </LoadingButton>
        </Box>
      </Box>
    </TabPaper>
  );
};
